import Vue from 'vue'
import store from '../store'

export default {
  loadProjects (clb, clbError) {
    Vue.http.get('/api/projects/list')
      .then(res => {
        clb(this.makeProjectTree(res.body))
      }, res => {
        Vue.notify({
          title: 'ERROR',
          text: 'Could not load projects',
          type: 'error'
        })
        clbError(res)
      })
  },
  makeProjectTree (list) {
    list.forEach(p => {
      p.name = p.name + (p.workpack ? ' (' + p.workpack.id + ')' : '')
    })
    let walk = (project) => {
      project['children'] = list.filter(p => p['parent_id'] === project['id'])
      project['children'].forEach(p => walk(p))
    }

    let roots = list.filter(p => p['parent_id'] === 0)
    let m = {}
    roots.forEach(r => {
      if (!m[r.id]) {
        m[r.id] = true
        walk(r)
      }
    })

    return roots
  },
  pollTaskStats ()  {
    let tm = () => {
      setTimeout(() => {
        this.pollTaskStats()
      }, 1000 * 20)
    }
    Vue.http.get('/api/projects/task-stats-all')
      .then(res => {
        this.mixinStats(res.body)
        tm()
      }, err => {
        tm()
      })
  },
  mixinStats (data) {
    let walk = (projects)=>{
      projects.forEach(p => {
        if (p.workpack) {
          data.forEach(d => {
            if (d.workpack_id === p.workpack.id) {
              p.workpack.tasks[d.process_state] = d.cnt
            }
          })
          if (p.children) {
            walk(p.children)
          }
        }
      })
    }

    walk(store.getters['project/projects'])
  }
}



// WEBPACK FOOTER //
// ./src/api/projects.js